export class File {
    [key: string]: any;
    checkDir(...args: any[]): any {}
    createDir(...args: any[]): any {}
    readAsText(...args: any[]): any {}
    readAsArrayBuffer(...args: any[]): any {}
    writeExistingFile(...args: any[]): any {}
    writeFile(...args: any[]): any {}
    resolveLocalFilesystemUrl(...args: any[]): any {}
}
export interface Entry {
    [key: string]: any;
}
export interface DirectoryEntry extends Entry {
    [key: string]: any;
}
export interface FileEntry extends Entry {
    createWriter(successCallback: (writer: FileWriter) => void, errorCallback?: any): void;
    file(successCallback: (file: IFile) => void, errorCallback?: any): void;
}
export interface IFile extends Blob {
    name: string;
    localURL: string;
    type: string;
    lastModified: number;
    lastModifiedDate: number;
    size: number;
    start: number;
    end: number;
}
export interface FileWriter {
    write(data: any): void;
    seek(offset: number): void;
    truncate(size: number): void;
    onwriteend: any;
    onerror: any;
    onabort: any;
    onwrite: any;
    position: number;
    length: number;
    error: any;
    readyState: number;
    abort(): void;
}
export type FileWriterCallback = Record<string, unknown>;
export type EntriesCallback = Record<string, unknown>;
export type ErrorCallback = any;
